import { Component, Input, Output, EventEmitter, input, OnInit } from '@angular/core';
import { ToastNotificationType } from '../../../models/toast-notification-type';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-toast-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-notification.component.html',
  styleUrl: './toast-notification.component.css',
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ToastNotificationComponent implements OnInit {

  message = input.required<string>();
  type = input.required<ToastNotificationType>();
  title = input.required<string>();

  @Output() closeNotification = new EventEmitter<void>();

  isVisible = true;
  notificationType = ToastNotificationType;

  ngOnInit(): void {
    setTimeout(() => {
      this.emitCloseNotification();
    }, 3500);
  }

  emitCloseNotification() {
    this.isVisible = false;

    setTimeout(() => {
      this.closeNotification.emit();
    }, 400);
  }
}
